import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetProjectRevenueSummaryQuery } from "../../../services/Reports";
import {
  getProjectRevenueSummaryRequest,
  getProjectRevenueSummaryFailure,
  getProjectRevenueSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allProjectRevenueSummary,
    isLoading: projectRevenueSummaryLoading,
    isError: projectRevenueSummaryError,
  } = useGetProjectRevenueSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.projectRevenueSummaryPageNo,
    pageSize: state.projectRevenueSummaryPageSize,
    fromDate: new Date(
      state.projectRevenueSummaryFromDate,
    ).toLocaleDateString(),
    toDate: new Date(state.projectRevenueSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectRevenueSummaryLoading) {
      dispatch(getProjectRevenueSummaryRequest());
    }
    if (projectRevenueSummaryError) {
      dispatch(getProjectRevenueSummaryFailure(projectRevenueSummaryError));
    }
    if (allProjectRevenueSummary) {
      dispatch(
        getProjectRevenueSummarySuccess({
          data: allProjectRevenueSummary.data.revenueSummary[0].data || [],
          totalPages:
            allProjectRevenueSummary.data.revenueSummary[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allProjectRevenueSummary,
    profileData,
    state.projectRevenueSummaryFromDate,
    state.projectRevenueSummaryToDate,
    state.projectRevenueSummaryPageNo,
    state.projectRevenueSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
